import { FieldArray, useFormikContext } from "formik";
import moment from "moment";
import { Button, Col, Row } from "react-bootstrap";
import Switch from "react-switch";
import colorRange from "Assets/images/colorRange.png";
import { MinusIcon, PlusCircleIcon, PlusIcon, PlusPurpleIcon } from "Assets/icons";
import { cloneDeep, map } from "lodash";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { trackerDefaultFields } from "config/reports";
import TrackerRangeSlider from "../TrackerRangeSlider/Index";

const QuestionTracker = ({ question, fieldName }) => {

  const { setFieldValue, getFieldMeta, values, errors } = useFormikContext();
  const fieldMeta = getFieldMeta(fieldName);
  const fieldValue = fieldMeta?.value;
  const trackerLabels = question?.question_dd_labels?.tracker || [];
  
  return (
    <>
      <h6 className="m-0 fw-sbold themeBlue pb-1 d-flex align-items-center gap-10">
        {question?.question}
        <Switch
          uncheckedIcon={""}
          checkedIcon={""}
          onHandleColor={"#A3DF00"}
          offHandleColor={"#A3DF00"}
          onColor={"#E6E6E6"}
          offColor={"#E6E6E6"}
          height={18}
          width={40}
          onChange={(isChecked) => {
            setFieldValue(`${fieldName}.other_details.visibility`, isChecked);
          }}
          checked={fieldValue?.other_details?.visibility}
        />
      </h6>
      {fieldValue?.other_details?.visibility && (
        <FieldArray name={`${fieldName}.other_details.tracking`}>
          {({ insert, remove, push }) => (
            fieldValue?.other_details?.tracking?.length > 0 && fieldValue?.other_details?.tracking?.map((row, index) => {
              return (
                <>
                  <div className="py-2">
                    <div className=" border rounded-3 p-3">
                      <div className="py-3">
                        <div className="d-flex align-itmes-center justify-content-between gap-10 mb-4">
                          <h6 className="m-0 fw-sbold themeBlue pb-1">
                            Observations
                          </h6>
                          <div className="d-flex">
                            <div className="d-flex align-items-center gap-10">
                              <AppInputField
                                name={`${fieldName}.other_details.tracking.${index}.date_time`}
                                aria-label="Date and time"
                                type="datetime-local"
                                className="form-control"
                              />
                            </div>
                            {index === 0 ? (
                              <Button
                                className="border-0 p-0 ms-3"
                                variant="transparent"
                                onClick={(e) => {
                                  push(cloneDeep(trackerDefaultFields))
                                }}
                              >
                                <PlusIcon />
                              </Button>
                            ) : (
                              <Button
                                className="border-0 p-0 ms-3"
                                variant="transparent"
                                onClick={(e) => {
                                  remove(index)
                                }}
                              >
                                <MinusIcon />
                              </Button>
                            )}
                          </div>
                        </div>
                        <div className="d-flex align-items-start gap-10 pb-3">
                          <AppInputField
                            name={`${fieldName}.other_details.tracking.${index}.notes`}
                            rows={4}
                            fieldType={"textarea"}
                            placeholder={question?.placeholder || ""}
                            className="form-control is-resizable-textarea"
                            style={{ background: "#F8F8F8" }}
                          />
                        </div>
                      </div>
                      <div className="py-3">
                        <Row>
                          <Col lg="6">
                            <TrackerRangeSlider
                              labels={trackerLabels}
                              value={
                                fieldValue?.other_details?.tracking?.length &&
                                fieldValue?.other_details?.tracking[index]?.percentage
                              }
                            >
                              <AppInputField
                                id="frequency-range"
                                className="frequency-range"
                                name={`${fieldName}.other_details.tracking.${index}.percentage`}
                                type={"range"}
                                min="0"
                                max="100"
                              />
                            </TrackerRangeSlider>
                            {/* <img
                                src={colorRange}
                                alt=""
                                className="img-fluid"
                              /> */}
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </>
              )
            })
          )}
        </FieldArray>
      )}
    </>
  )
}

export default QuestionTracker;